import { makeRequest } from "../../../apiCalls/utils/makeRequest";
import { globalAxiosInstance } from "../../../apiCalls/utils/axios";

type DeleteVehicleTemplateRequest = {
  templateId?: string;
};

export const useDeleteVehicleTemplate = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "delete",
  buildQuery: ({ data }) => `/vehicles/templates/${data?.templateId}`,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  buildData: (_: DeleteVehicleTemplateRequest) => ({}),
});
